/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsComposeDetailVo } from './GoodsComposeDetailVo';
import {
    GoodsComposeDetailVoFromJSON,
    GoodsComposeDetailVoFromJSONTyped,
    GoodsComposeDetailVoToJSON,
    GoodsComposeDetailVoToJSONTyped,
} from './GoodsComposeDetailVo';

/**
 * 
 * @export
 * @interface ResponseGoodsComposeDetailVo
 */
export interface ResponseGoodsComposeDetailVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGoodsComposeDetailVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGoodsComposeDetailVo
     */
    message?: string;
    /**
     * 
     * @type {GoodsComposeDetailVo}
     * @memberof ResponseGoodsComposeDetailVo
     */
    data?: GoodsComposeDetailVo;
}

/**
 * Check if a given object implements the ResponseGoodsComposeDetailVo interface.
 */
export function instanceOfResponseGoodsComposeDetailVo(value: object): value is ResponseGoodsComposeDetailVo {
    return true;
}

export function ResponseGoodsComposeDetailVoFromJSON(json: any): ResponseGoodsComposeDetailVo {
    return ResponseGoodsComposeDetailVoFromJSONTyped(json, false);
}

export function ResponseGoodsComposeDetailVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGoodsComposeDetailVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GoodsComposeDetailVoFromJSON(json['data']),
    };
}

export function ResponseGoodsComposeDetailVoToJSON(json: any): ResponseGoodsComposeDetailVo {
    return ResponseGoodsComposeDetailVoToJSONTyped(json, false);
}

export function ResponseGoodsComposeDetailVoToJSONTyped(value?: ResponseGoodsComposeDetailVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GoodsComposeDetailVoToJSON(value['data']),
    };
}

